module.exports = __webpack_public_path__ + "img/csa_capital_market.aa4d9ed5.png";